export default __webpack_public_path__ + "static/media/5041.92499001.png";